import { Inject, Injectable, PLATFORM_ID, inject } from "@angular/core";
import { OfferUtilService, PqpsUtilService } from "src/app/common/services";
import { MktEnvironmentService } from "src/app/core/services";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { WINDOW, WindowRef } from '@citi-gcg-173875/citi-utils';
import { PdpDataTransformService } from "./pdp-data-transform.service";

@Injectable({
    providedIn: 'root'
})
export class PdpRedesignService {

    public aemImagePrefix: string;
    public isBrowser: boolean;
    public isMobile = false;
    public pricingData = { dynamicOffer: {}, dynamicUrls: {}, isMobilePriceLoaded: false, isDesktopPriceLoaded: false };
    public pid = '';
    public productType = '';
    public pidPT = '';
    public pageQueryParams = '';

    constructor(
        private pqpsUtilService: PqpsUtilService,
        private _offerUtilService: OfferUtilService,
        private _mktEnvironmentService: MktEnvironmentService,
        private pdpDataTransformService: PdpDataTransformService,
        @Inject(PLATFORM_ID) private _platformId: string,
        @Inject(DOCUMENT) private _document: Document,
        @Inject(WINDOW) private _window: WindowRef,
    ) {
        this.isBrowser = isPlatformBrowser(this._platformId);
    }

    getDataBasedOnPageType(data: any, pageType: string) {
        console.log(`>>> ${pageType}: Processing data for Page`);
        if(pageType === 'family'){
            const compList = this.pdpDataTransformService.transform(data);
            const familyCardMetadata = compList?.reduce((metadata: any[], item: any) => {
                const cards = item?.data?.familyCardsItems?.map(card => card?.cardDetail) || [];
                return [...metadata, ...cards];
            }, []);
          let result = {
              'metadata': familyCardMetadata,
              'pageInfo': data.page.item.pageInfo,
              'componentList': compList
              };
          return result;
          }
        else {
            data.page.item.cardData.cardMetadata = { ...data.page.item?.cardData?.cardMetadata, 'oc': data.page.item.pageInfo['oc'] };
            let result = {
                'metadata': [{ ...data.page.item?.cardData?.cardMetadata, 'pid': data.page?.item?.cardData?.cardPid, 'contentId': data.page.item.cardData.contentId, 'cardName': data.page.item.cardData.cardName.plaintext }],
                'additionalInfoData': data.page.item.cardData.additionalInformation,
                'pageInfo': data.page.item.pageInfo,
                'componentList': this.pdpDataTransformService.transform(data)
            };
            this.pid = result?.metadata[0]?.pid || '';
            this.productType = result?.metadata[0]?.productType || '';
            this.pidPT = this.productType ? `${this.pid}_${this.productType}` : this.pid;
            return result;
        }

    }

    setPDPLink(link: any, flowParams?) {
        if (!link) return;
        if (!flowParams && this._offerUtilService.flowParams) flowParams = this._offerUtilService.flowParams;
        const sanatizedFlowParams = this._offerUtilService.sanitizeObject(flowParams);
        if (typeof link === 'string') {
            link = this.setParamsToURL(link, `category=${sanatizedFlowParams.category},intc=${sanatizedFlowParams.intc},afc=${sanatizedFlowParams.afc},flowId=${sanatizedFlowParams.flowId}`);
            return link;
        }
        link.href = this.setParamsToURL(link.href, `category=${sanatizedFlowParams.category},intc=${sanatizedFlowParams.intc},afc=${sanatizedFlowParams.afc},flowId=${sanatizedFlowParams.flowId}`);
        return link.href;
    }

    public getDynamicUrls({ priceObj, pageId, flowParams, mbolParams }) {
        if (!priceObj) return;
        const sanatizedFlowParams = this._offerUtilService.sanitizeObject(flowParams);
        const sanatizedFlowParamsTextFormat = Object.entries(sanatizedFlowParams)
            .map(([key, value]) => key + '=' + value)
            .join(',');
        // priceObj.uniqueId = `${priceObj.productIdentifier}-${priceObj.productType}`
        priceObj.pricingInfoLink = priceObj["terms-link"];
        flowParams.pid = priceObj.productIdentifier; 
        // set internal URL parameters as received
        this.setInternalURLParam();
        this._offerUtilService.setPDPLink(flowParams);

        switch (pageId) {
            case 'CITICRSNGA':
                if (priceObj.applyNowLink) {
                    priceObj.applyNowURL = priceObj.applyNowLink;
                }
                break;
            case 'CITIPQPSNGA':
                priceObj.applyNowURL = this.pqpsUtilService.getPQPSApplyNowUrl(priceObj["hashCode"], priceObj?.offerHashKey, sanatizedFlowParams.acquisitionType, sanatizedFlowParams?.invitationNumber, priceObj?.PID, sanatizedFlowParams?.aoOfferParams, sanatizedFlowParams?.oc);
                break;
            case 'CitiPDPNGA':
            case 'CitiRAFNGA':
                priceObj.applyNowURL = priceObj.isMbol ? priceObj['mbol-apply-now-button'] : priceObj['apply-now-button'];
                priceObj.pdpPageLink = this.setPDPLink(priceObj.pdpPageLink, sanatizedFlowParams);
        }
    }

    setParamsToURL = (url, value) => {
        const origin = this._mktEnvironmentService.getEnvironmentVar("cardsmkrHostName");
        let newUrl = new URL(url, origin);
        let params = value.split(",");
        params = params.filter(val => val.split('=')[1]);
        newUrl.search = `?${params.join('&')}`;
        return newUrl;
    };


    public aaApplyNow(applyNowUrl: string, flowParams?: any) {
        if (!flowParams && this._offerUtilService.flowParams) flowParams = this._offerUtilService.flowParams;
        if (applyNowUrl &&  flowParams['isAACategory']) {
            if(!applyNowUrl.includes('PO=')){
              let urlObj = applyNowUrl?.split('?');
              let baseUrl = urlObj?.[0];
              let params = urlObj?.[1];
              applyNowUrl = baseUrl + `?PO=${flowParams['PO']}&` + params;
            }
            if(flowParams['cmp'] && !applyNowUrl.includes('cmp=')){
              applyNowUrl += `&cmp=${flowParams['cmp']}`;
            }
        }
        return applyNowUrl;
    }

    loadDynamicStyle(styleUrl: string) {
        return new Promise((resolve, reject) => {
            const head = this._document.getElementsByTagName('head')[0];
            const link = this._document.createElement('link');
            link.rel = 'stylesheet';
            link.href = styleUrl;
            link.onload = resolve;
            link.onerror = reject;
            head.appendChild(link);
        });
    }

    public setDeviceSize() {
        const size = this._window['innerWidth'] || 992;
        this.isMobile = false;
        if (size < 992) {
            this.isMobile = true;
        }
    }

    public setInternalURLParam(): void {
        const queryParams = this._window['location']?.search?.replace('?', '') || '';    
        if (!queryParams) return;
        let queryParamsMap = new URLSearchParams(queryParams);        
        const links = this._document.querySelectorAll<HTMLAnchorElement>('a[data-id="internal"]');

        links.forEach((link) => {
            if (link?.href) {
                const url = new URL(link.href);
                queryParamsMap?.forEach((value, key) => {
                    // Add and also update the param if the key already exists in the URL
                    url.searchParams.set(key, value);
                });
                // Remove cmp to avoid creating duplicate PDP/MPP cookies
                url.searchParams.delete('cmp');
                url.searchParams.delete('HKOP');
                link.href = url.toString();
            }
        
        });
    
    }
}
